export default __webpack_public_path__ + "static/media/1920 knife block A side.92b64ba8.png";